export const languages = [
  { name: 'NORAM', lang: 'en-us', flag: 'US' },
  { name: 'EMEA', lang: 'en-gb', flag: 'GB' },
  { name: 'APAC', lang: 'en-au', flag: 'AU' },
];
